export class Piece {
    constructor(
        public id?: number,
        public code?: string,
        public libelle?: string,
        public aide?: string,
        public descriptif?: string,
        public obligatoire?: boolean,
        public exportRentree?: boolean,
        public categorieFormationId?: number,
        public formationId?: number,
        public ordre?: number,
        public commonIds?: number[],
        public libelleEn?: string,
        public aideEn?: string,
        public descriptifEn?: string
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/formation/piece.model.ts